// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"113e7b82","452":"21f4e7e7"}[chunkId] + ".chunk.css";
};